import { render, staticRenderFns } from "./DietCard.vue?vue&type=template&id=7bbab539&scoped=true"
import script from "./DietCard.vue?vue&type=script&lang=js"
export * from "./DietCard.vue?vue&type=script&lang=js"
import style0 from "./DietCard.vue?vue&type=style&index=0&id=7bbab539&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbab539",
  null
  
)

export default component.exports